import type { ReactElement } from "react";
import useTooltipItemListCount from "../../../../hooks/signals-tooltip/useTooltipItemListCount";
import type SignalsTooltipViewModel from "../../../../models/view/signals-tooltip/SignalsTooltipViewModel";
import SignalsTooltipTable from "../SignalsTooltipTable/SignalsTooltipTable";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

type Props = {
    className?: string;
    createViewModel(itemsLimit: number): SignalsTooltipViewModel;
    renderOverLimitView(props: { items: SignalsTooltipViewModel["otherItems"] }): ReactElement;
};

const SignalsTooltipTableView = ({ className, createViewModel, renderOverLimitView: OverLimitView }: Props) => {
    const maxItemsCount = useTooltipItemListCount();

    const vm = createViewModel(maxItemsCount);
    const tableColumns = vm.getPresentationDetailList();
    const t = useTranslation();

    return (
        <>
            <SignalsTooltipTable
                className={className}
                columns={tableColumns}
                data={vm.visibleItems}
                translations={{
                    outOf: t("common.minitable.pager.out_of"),
                    pages: t("Common.minitable.pager.pages"),
                }}
            />

            {vm.otherItems.length === 0 ? null : (
                <OverLimitView
                    data-automation="list-over-limit-element"
                    items={vm.otherItems}
                />
            )}
        </>
    );
};

export default SignalsTooltipTableView;
